import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplymentModel {

  public selectiveProcessOptions: any[] = new Array();
  public settings: any = {};
  public logged = false;
  public personName =  null;
  public shouldStopRedirectFromRootUrl = false;

  constructor() {
  }

  setSelectiveProcess(data) {
    if (data) {
      this.selectiveProcessOptions = data;
    } else {
      this.selectiveProcessOptions = new Array();
    }
  }

  getSelectiveProcess() {
    return this.selectiveProcessOptions;
  }

  setLogged(logged) {
    this.logged = logged;
  }

  getLogged() {
    return this.logged;
  }

  setPersonName(name) {
    this.personName = name;
  }

  setSettings(data) {
    if (data) {
      this.settings = data;
      this.setInstitutionalColorCSSVariable(this.settings.institutional_color);
    } else {
      this.settings = {};
    }
  }

  getSettings() {
    return this.settings;
  }

  private setInstitutionalColorCSSVariable(color) {
    document.documentElement.style.setProperty('--institutional-color', color);
  }

}
